import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/photos/close.png'


const _withScopeId = n => (_pushScopeId("data-v-2b2525e1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "add-main" }
const _hoisted_2 = { class: "add-container" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "add-container-row" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "add-row-label" }, "Folder", -1))
const _hoisted_6 = {
  key: 0,
  class: "add-container-row"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "add-row-label" }, "Images", -1))
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = {
  key: 3,
  class: "loader"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader-circle" }, null, -1))
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = {
  key: 0,
  class: "thumbnail-title"
}
const _hoisted_15 = {
  class: "thumbnail-container",
  ref: "thumbnailContainer"
}
const _hoisted_16 = ["src", "onClick"]
const _hoisted_17 = {
  key: 0,
  class: "full-image-container"
}
const _hoisted_18 = { class: "image-container" }
const _hoisted_19 = { class: "container-header" }
const _hoisted_20 = ["src"]
const _hoisted_21 = { class: "container-footer" }
const _hoisted_22 = ["href"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"100%","text-align":"center"} }, "Are you sure you want to delete this photo?", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Popup = _resolveComponent("Popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.settingsJson.access == 'ADMIN' ? 'Add' : 'View') + " Photos", 1),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.folderName) = $event)),
          disabled: true
        }, null, 512), [
          [_vModelText, _ctx.folderName]
        ])
      ]),
      (_ctx.settingsJson.access == 'ADMIN')
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("input", {
              type: "file",
              ref: "fileInput",
              multiple: "",
              onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.imageChange && _ctx.imageChange(...args))),
              accept: "image/*",
              disabled: _ctx.loading
            }, null, 40, _hoisted_8)
          ]))
        : _createCommentVNode("", true),
      (_ctx.settingsJson.access == 'ADMIN')
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addClicked && _ctx.addClicked(...args))),
            disabled: _ctx.loading
          }, "Add", 8, _hoisted_9))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "error-message",
        innerHTML: _ctx.addErrorMessage
      }, null, 8, _hoisted_10),
      (_ctx.showCreateFolderButton)
        ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.createFolderClicked && _ctx.createFolderClicked(...args)))
          }, "Create Folder and Upload"))
        : _createCommentVNode("", true),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", {
              class: "loader-text",
              innerHTML: _ctx.loadingText
            }, null, 8, _hoisted_13)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.thumbnailList.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, "Total of " + _toDisplayString(_ctx.thumbnailList.length) + " photos", 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_15, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.thumbnailList, (t, i) => {
        return (_openBlock(), _createElementBlock("img", {
          key: i,
          class: "image-thumbnail",
          style: _normalizeStyle(_ctx.thumbnailSize),
          src: t,
          onClick: ($event: any) => (_ctx.thumbnailClicked(t))
        }, null, 12, _hoisted_16))
      }), 128))
    ], 512),
    _createVNode(_Transition, { name: "full-image-transition" }, {
      default: _withCtx(() => [
        (_ctx.showFullImage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("img", {
                    src: _imports_0,
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showFullImage = false))
                  })
                ]),
                _createElementVNode("img", {
                  class: "full-image",
                  src: _ctx.fullImageLink,
                  alt: ""
                }, null, 8, _hoisted_20),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("a", {
                    class: "download-button",
                    href: `${_ctx.fullImageLink}&download=true`,
                    download: ""
                  }, "Download", 8, _hoisted_22),
                  (_ctx.settingsJson.access == 'ADMIN')
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "delete-button",
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.deleteImageClicked && _ctx.deleteImageClicked(...args)))
                      }, "Delete"))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_Popup, {
      showPopup: _ctx.showDeletePopup,
      onButtonClicked: _ctx.deletePopupButtonClicked,
      title: "Delete Photo",
      buttons: [
        { buttonText: 'Delete', backgroundColor: 'red', color: 'white' },
        { buttonText: 'Cancel', backgroundColor: 'gray', color: 'white' },
      ]
    }, {
      default: _withCtx(() => [
        _hoisted_23
      ]),
      _: 1
    }, 8, ["showPopup", "onButtonClicked"])
  ]))
}